export interface Feature {
  name: string;
  subitems?: string[];
  subtitle?: string;
}

export const allFeatures: Feature[] = [
  {
    name: 'Przewodnik po Teneryfie - 170 stron',
    subtitle: 'praktyczne informacje, ciekawostki i wskazówki',
    subitems: [
      'Interaktywna mapa ze 170 miejscami do zobaczenia',
      'Szlaki turystyczne i trasy spacerowe + linki do map',
      'Najlepsze plaże, baseny i wodne atrakcje',
      'Plany zwiedzania na 4, 7 i 10 dni',
      'Lista polecanych restauracji',
      'Wygodny format PDF',
    ],
  },
  {
    name: 'Edytowalny planer podróży',
    subtitle: 'uniwersalny planer w pełni edytowalny',
    subitems: [
      'Budżet z kalkulatorem walut',
      'Lista rzeczy do zabrania',
      'Checklista podróżna',
      'Kalendarz aktywności',
      'Twój plan podróży',
      'Miejsce na notatki',
      'Wersja Excel i Google Sheets',
    ],
  },
  {
    name: 'Indywidualny plan podróży dla Ciebie',
    subtitle: 'przygotowany na podstawie ankiety',
    subitems: [
      'Przykładowe loty lub oferty z biura podróży (w wybranym przez Ciebie terminie)',
      'Rekomendowane noclegi (w oparciu o Twoje preferencje)',
      'Plan dojazdu z lotniska do Twojego hotelu',
      'Szczegółowy plan zwiedzania dopasowany do Twojego stylu wypoczynku i preferowanych atrakcji',
      'Indywidualne rekomendacje',
    ],
  },
];

export interface PricingPlan {
  badge: string;
  checkoutUrl: string;
  comparedAtPrice?: number;
  description: string;
  discountPrice?: string;
  features: Feature[];
  id: string;
  image: string;
  name: 'Podstawowy' | 'Rozszerzony' | 'Premium';
  price: number;
}

export const COUNTDOWN_DATE = new Date('2025-12-01T00:00:00');
export const DISCOUNT_CODE = 'PRZYGODA30';
export const SHOW_DISCOUNT = false;

const isProduction = process.env.ENVIRONMENT === 'production';

export const pricingPlans: PricingPlan[] = [
  {
    id: isProduction ? 'prod_RpOo8kPNxy5YnT' : 'prod_RpOGiAbRj2u12a',
    name: 'Podstawowy',
    description: 'Samodzielnie zaplanuj wyjazd',
    price: 89,
    discountPrice: '62,30',
    comparedAtPrice: 134,
    badge: 'Sam przewodnik 📖',
    features: [allFeatures[0]],
    checkoutUrl: isProduction
      ? 'https://buy.stripe.com/3cscOb9ADd8g4P6aEE'
      : '/',
    image: '/static/images/teneryfa/price-1.jpg',
  },
  {
    id: isProduction ? 'prod_RpOqmHHp03Lnge' : 'prod_RpOIa186Ls9rKU',
    name: 'Rozszerzony',
    description: 'Z dodatkowym, edytowalnym planerem podróży',
    price: 99,
    discountPrice: '69,30',
    comparedAtPrice: 149,
    badge: 'Najczęściej wybierany 🔥',
    features: allFeatures.slice(0, 2),
    checkoutUrl: isProduction
      ? 'https://buy.stripe.com/cN28xV003fgoa9qfYZ'
      : '/',
    image: '/static/images/teneryfa/price-2.jpg',
  },
  {
    id: isProduction ? 'prod_S2u0xGegCmdeuE' : 'prod_S2u3iHUsuJckgf',
    name: 'Premium',
    description: 'Przewodnik, planer i indywidualny plan podróży',
    price: 249,
    discountPrice: '174,30',
    comparedAtPrice: 379,
    badge: 'Przygotowany dla Ciebie ✨',
    features: allFeatures,
    checkoutUrl: isProduction
      ? 'https://buy.stripe.com/9AQ5lJ9AD1pygxOeUX'
      : '/',
    image: '/static/images/teneryfa/price-3.jpg',
  },
];

const getMessageContent = (productName: string): string => {
  switch (productName) {
    case 'Podstawowy':
      return `
        <div style="font-family: Roboto, Tahoma, sans-serif; max-width: 650px; margin: 0 auto; padding: 20px; background-color: #fafafa; border-radius: 10px; box-shadow: 0 4px 8px rgba(0,0,0,0.05);">
          <div style="margin-bottom: 20px;">
            <h1 style="color: #333; margin-bottom: 10px; font-size: 24px">🏝️ Teneryfa. Praktyczny Przewodnik</h1>
            <div style="width: 150px; height: 4px; background: linear-gradient(90deg, rgb(251, 108, 70), rgb(240, 152, 25)); margin-bottom: 45px;"></div>
          </div>
          
          <div style="margin-bottom: 25px;">
            <p style="font-size: 18px;"><strong>Cześć Podróżniczy Entuzjasto!</strong></p>
            <p style="line-height: 1.6;">Właśnie stajesz się szczęśliwym posiadaczem mojego <strong>(a teraz już Twojego!)</strong> przewodnika po Teneryfie! 🏝️✨ Bardzo Ci dziękuję za zaufanie i zakup tego e-booka. To wiele dla mnie znaczy!</p>
            <p style="line-height: 1.6;">Nie mogę się doczekać, aż odkryjesz jego zawartość i zaplanujesz swoją podróż niczym sprytny lis 🦊 – bez zbędnego stresu, ale za to z pewnością, że nie ominie Cię nic wartego zobaczenia.</p>
          </div>
          
          <div style="background-color: #f2f2f2; padding: 20px; border-radius: 8px; margin-bottom: 25px;">
            <p style="font-size: 18px; color: #333; margin-top: 0;"><strong>Oto Twój plan działania:</strong></p>
            
            <div style="display: flex; margin-bottom: 15px; align-items: flex-start;">
              <div style="min-width: 30px; color: rgb(251, 108, 70);"><strong>✅</strong></div>
              <div>
                <p style="margin: 0; line-height: 1.6;">
                  <strong>Krok 1: Pobierz przewodnik, klikając w ten magiczny link:</strong>
                  <div style="text-align: center; margin: 20px 0 20px 0">
                    <a href="__EBOOK_LINK__" style="
                      display: inline-block;
                      padding: 12px 25px;
                      background: linear-gradient(128deg, rgb(255, 88, 88) 7%, rgb(240, 152, 25) 100%);
                      color: white;
                      text-decoration: none;
                      font-weight: bold;
                      border-radius: 999px;
                      text-align: center;
                      min-width: 180px;
                      box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
                    ">Przewodnik</a>
                  </div>
                  Ale uwaga – <strong>masz tylko 7 dni</strong>, zanim zniknie on w otchłani internetu, więc nie zwlekaj i pobierz go jak najszybciej ⏳
                </p>
              </div>
            </div>
            
            <div style="display: flex; margin-bottom: 15px; align-items: flex-start;">
              <div style="min-width: 30px; color: rgb(251, 108, 70);"><strong>✅</strong></div>
              <div>
                <p style="margin: 0; line-height: 1.6;"><strong>Krok 2: Wskocz w środek przygody!</strong> W przewodniku znajdziesz sprawdzone atrakcje, ukryte perełki i konkretne wskazówki, które oszczędzą Ci stresu, czasu i przygotowań. Wydeptałam już te ścieżki dla Ciebie, więc śmiało korzystaj!</p>
              </div>
            </div>
            
            <div style="display: flex; align-items: flex-start;">
              <div style="min-width: 30px; color: rgb(251, 108, 70);"><strong>✅</strong></div>
              <div>
                <p style="margin: 0; line-height: 1.6;"><strong>Krok 3: Leć na Teneryfę, eksploruj i daj mi znać, jak było!</strong> Jeśli chcesz podzielić się swoimi wrażeniami, oznacz mnie na Instagramie <a style="color: rgb(251, 108, 70); text-decoration: none; font-weight: bold; border-bottom: 1px solid rgb(251, 108, 70);" href="https://www.instagram.com/foxparadox.insta/"><strong>@foxparadox.insta</strong></a> – z przyjemnością zobaczę Twoje podróżnicze chwile!</p>
              </div>
            </div>
          </div>
          
          <p style="line-height: 1.6;">A jeśli po przeczytaniu przewodnika będziesz mieć pytania lub zechcesz się ze mną podzielić opinią – śmiało pisz! Twoja feedbackowa supermoc pomoże mi tworzyć jeszcze lepsze materiały w przyszłości. 📙</p>
          
          <div style="margin-top: 30px; padding-top: 20px; border-top: 1px solid #ddd;">
            <p style="margin-bottom: 5px;">Miłego odkrywania,</p>
            <p style="font-weight: bold; margin-top: 0;">Magda Szabłowska</p>
          </div>
          
          <div style="text-align: center; margin-top: 20px; padding: 15px; background-color: #f9f9f9; border-radius: 8px;">
            <p style="margin: 0; font-size: 15px;">
              <strong>Instagram: <a style="color: rgb(251, 108, 70); text-decoration: none;" href="https://www.instagram.com/foxparadox.insta/">@foxparadox.insta</a></strong> | 
              <strong>Strona: <a style="color: rgb(240, 152, 25); text-decoration: none;" href="https://www.foxparadox.pl">www.foxparadox.pl</a></strong>
            </p>
          </div>
        </div>
      `;
    case 'Rozszerzony':
      return `
        <div style="font-family: Roboto, Tahoma, sans-serif; max-width: 650px; margin: 0 auto; padding: 20px; background-color: #fafafa; border-radius: 10px; box-shadow: 0 4px 8px rgba(0,0,0,0.05);">
          <div style="margin-bottom: 20px;">
            <h1 style="color: #333; margin-bottom: 10px; font-size: 24px">🏝️ Teneryfa. Praktyczny Przewodnik</h1>
            <div style="width: 150px; height: 4px; background: linear-gradient(90deg, rgb(251, 108, 70), rgb(240, 152, 25)); margin-bottom: 45px;"></div>
          </div>
          
          <div style="margin-bottom: 25px;">
            <p style="font-size: 18px;"><strong>Cześć Podróżniczy Entuzjasto!</strong></p>
            <p style="line-height: 1.6;">Właśnie stajesz się szczęśliwym posiadaczem mojego <strong>(a teraz już Twojego!)</strong> przewodnika po Teneryfie! 🏝️✨ Bardzo Ci dziękuję za zaufanie i zakup tego e-booka. To wiele dla mnie znaczy!</p>
            <p style="line-height: 1.6;">Nie mogę się doczekać, aż odkryjesz jego zawartość i zaplanujesz swoją podróż niczym sprytny lis 🦊 – bez zbędnego stresu, ale za to z pewnością, że nie ominie Cię nic wartego zobaczenia.</p>
          </div>
          
          <div style="background-color: #f2f2f2; padding: 20px; border-radius: 8px; margin-bottom: 25px;">
            <p style="font-size: 18px; color: #333; margin-top: 0;"><strong>Oto Twój plan działania:</strong></p>
            
            <div style="display: flex; margin-bottom: 15px; align-items: flex-start;">
              <div style="min-width: 30px; color: rgb(251, 108, 70);"><strong>✅</strong></div>
              <div>
                <p style="margin: 0; line-height: 1.6;">
                  <strong>Krok 1: Pobierz przewodnik, klikając w ten magiczny link:</strong>
                  <div style="text-align: center; margin: 20px 0 20px 0">
                    <a href="__EBOOK_LINK__" style="
                      display: inline-block;
                      padding: 12px 25px;
                      background: linear-gradient(128deg, rgb(255, 88, 88) 7%, rgb(240, 152, 25) 100%);
                      color: white;
                      text-decoration: none;
                      font-weight: bold;
                      border-radius: 999px;
                      text-align: center;
                      min-width: 180px;
                      box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
                    ">Przewodnik</a>
                  </div>
                  Ale uwaga – <strong>masz tylko 7 dni</strong>, zanim zniknie on w otchłani internetu, więc nie zwlekaj i pobierz go jak najszybciej ⏳
                </p>
              </div>
            </div>
            
            <div style="display: flex; margin-bottom: 15px; align-items: flex-start;">
              <div style="min-width: 30px; color: rgb(251, 108, 70);"><strong>✅</strong></div>
              <div>
                <p style="margin: 0 0 10px 0; line-height: 1.6;"><strong>Krok 2:</strong> W pakiecie masz też <strong>mój autorski Planer Podróży</strong>, oto jak go pobrać:</p>
                <ul style="margin: 0; list-style: none; padding-left: 0;">
                  <li style="margin-bottom: 10px; position: relative; padding-left: 15px;">
                    <strong>Wersja Excel:</strong> Pobierz plik stąd: <strong><a style="color: rgb(251, 108, 70); text-decoration: none; border-bottom: 1px solid rgb(251, 108, 70);" href="__PLANER_EXCEL_LINK__">Fox Paradox Planer</a></strong> i zapisz go na swoim urządzeniu. To wszystko! Plik jest gotowy do edycji! 💻
                  </li>
                  <li style="position: relative; padding-left: 15px;">
                    <strong>Wersja Google Sheets:</strong> Kliknij tutaj: <strong><a style="color: rgb(251, 108, 70); text-decoration: none; border-bottom: 1px solid rgb(251, 108, 70);" href="__PLANER_GOOGLE_SHEETS_LINK__">Fox Paradox Planer</a></strong>, zaloguj się na konto Google, a następnie kliknij "Utwórz kopię", aby zapisać własny egzemplarz na swoim Dysku Google Drive. Od teraz możesz edytować arkusz i dostosować go do swoich potrzeb! 🚀
                  </li>
                </ul>
              </div>
            </div>
            
            <div style="display: flex; margin-bottom: 15px; align-items: flex-start;">
              <div style="min-width: 30px; color: rgb(251, 108, 70);"><strong>✅</strong></div>
              <div>
                <p style="margin: 0; line-height: 1.6;"><strong>Krok 3: Wskocz w środek przygody!</strong> W przewodniku znajdziesz sprawdzone atrakcje, ukryte perełki i konkretne wskazówki, które oszczędzą Ci stresu, czasu i przygotowań. Wydeptałam już te ścieżki dla Ciebie, więc śmiało korzystaj!</p>
              </div>
            </div>
            
            <div style="display: flex; align-items: flex-start;">
              <div style="min-width: 30px; color: rgb(251, 108, 70);"><strong>✅</strong></div>
              <div>
                <p style="margin: 0; line-height: 1.6;"><strong>Krok 4: Leć na Teneryfę, eksploruj i daj mi znać, jak było!</strong> Jeśli chcesz podzielić się swoimi wrażeniami, oznacz mnie na Instagramie <a style="color: rgb(251, 108, 70); text-decoration: none; font-weight: bold; border-bottom: 1px solid rgb(251, 108, 70);" href="https://www.instagram.com/foxparadox.insta/"><strong>@foxparadox.insta</strong></a> – z przyjemnością zobaczę Twoje podróżnicze chwile!</p>
              </div>
            </div>
          </div>
          
          <p style="line-height: 1.6;">A jeśli po przeczytaniu przewodnika będziesz mieć pytania lub zechcesz się ze mną podzielić opinią – śmiało pisz! Twoja feedbackowa supermoc pomoże mi tworzyć jeszcze lepsze materiały w przyszłości. 📙</p>
          
          <div style="margin-top: 30px; padding-top: 20px; border-top: 1px solid #ddd;">
            <p style="margin-bottom: 5px;">Miłego odkrywania,</p>
            <p style="font-weight: bold; margin-top: 0;">Magda Szabłowska</p>
          </div>
          
          <div style="text-align: center; margin-top: 20px; padding: 15px; background-color: #f9f9f9; border-radius: 8px;">
            <p style="margin: 0; font-size: 15px;">
              <strong>Instagram: <a style="color: rgb(251, 108, 70); text-decoration: none;" href="https://www.instagram.com/foxparadox.insta/">@foxparadox.insta</a></strong> | 
              <strong>Strona: <a style="color: rgb(240, 152, 25); text-decoration: none;" href="https://www.foxparadox.pl">www.foxparadox.pl</a></strong>
            </p>
          </div>
        </div>
      `;
    case 'Premium':
      return `
        <div style="font-family: Roboto, Tahoma, sans-serif; max-width: 650px; margin: 0 auto; padding: 20px; background-color: #fafafa; border-radius: 10px; box-shadow: 0 4px 8px rgba(0,0,0,0.05); color: #333;">
          <div style="margin-bottom: 20px;">
            <h1 style="color: #333; margin-bottom: 10px; font-size: 24px">🏝️ Teneryfa. Praktyczny Przewodnik</h1>
            <div style="width: 150px; height: 4px; background: linear-gradient(90deg, rgb(251, 108, 70), rgb(240, 152, 25)); margin-bottom: 45px;"></div>
          </div>
          
          <div style="margin-bottom: 25px;">
            <p style="font-size: 18px;"><strong>Cześć Podróżniczy Entuzjasto!</strong></p>
            <p style="line-height: 1.6;">Właśnie stajesz się szczęśliwym posiadaczem mojego <strong>(a teraz już Twojego!)</strong> przewodnika po Teneryfie! 🏝️✨ Cieszę się ogromnie, że obdarzasz mnie takim zaufaniem i wybierasz <strong>wersję Premium</strong>! To znaczy, że wspólnie przygotujemy plan Twojej wyjątkowej podróży!</p>
            <p style="line-height: 1.6;">Nie mogę się doczekać, aż odkryjesz jego zawartość i zaplanujesz swoją podróż niczym sprytny lis 🦊 – bez zbędnego stresu, ale za to z pewnością, że nie ominie Cię nic wartego zobaczenia.</p>
          </div>
          
          <div style="background-color: #f2f2f2; padding: 20px; border-radius: 8px; margin-bottom: 25px;">
            <p style="font-size: 18px; color: #333; margin-top: 0;">Oto, co teraz robimy:</p>
            
            <div style="display: flex; margin-bottom: 15px; align-items: flex-start;">
              <div style="min-width: 30px; color: rgb(251, 108, 70);"><strong>✅</strong></div>
              <div>
                <p style="margin: 0; line-height: 1.6;">
                  <strong>Krok 1: Pobierz przewodnik, klikając w ten magiczny link:</strong>
                  <div style="text-align: center; margin: 20px 0 20px 0">
                    <a href="__EBOOK_LINK__" style="
                      display: inline-block;
                      padding: 12px 25px;
                      background: linear-gradient(128deg, rgb(255, 88, 88) 7%, rgb(240, 152, 25) 100%);
                      color: white;
                      text-decoration: none;
                      font-weight: bold;
                      border-radius: 999px;
                      text-align: center;
                      min-width: 180px;
                      box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
                    ">Przewodnik</a>
                  </div>
                  Ale uwaga – <strong>masz tylko 7 dni</strong>, zanim zniknie on w otchłani internetu, więc nie zwlekaj i pobierz go jak najszybciej ⏳
                </p>
              </div>
            </div>
            
            <div style="display: flex; margin-bottom: 15px; align-items: flex-start;">
              <div style="min-width: 30px; color: rgb(251, 108, 70);"><strong>✅</strong></div>
              <div>
                <p style="margin: 0; line-height: 1.6;"><strong>Krok 2: Wypełnij krótką ankietę</strong>, abym mogła stworzyć dla Ciebie <strong>Spersonalizowany Plan Podróży</strong> dopasowany do Twojego stylu zwiedzania, budżetu i zainteresowań. To dosłownie kilka minut, a dzięki temu dostaniesz gotowy plan skrojony na miarę! <a style="color: rgb(251, 108, 70); text-decoration: none; font-weight: bold; border-bottom: 1px solid rgb(251, 108, 70);" href="__GOOGLE_FORM_LINK__"><strong>Link do ankiety</strong></a></p>
              </div>
            </div>
            
            <div style="display: flex; margin-bottom: 15px; align-items: flex-start;">
              <div style="min-width: 30px; color: rgb(251, 108, 70);"><strong>✅</strong></div>
              <div>
                <p style="margin: 0 0 10px 0; line-height: 1.6;"><strong>Krok 3:</strong> W pakiecie masz też <strong>mój autorski Planer Podróży</strong>, oto jak go pobrać:</p>
                <ul style="margin: 0; list-style: none; padding-left: 0;">
                  <li style="margin-bottom: 10px; position: relative; padding-left: 15px;">
                    <strong>Wersja Excel:</strong> Pobierz plik stąd: <strong><a style="color: rgb(251, 108, 70); text-decoration: none; border-bottom: 1px solid rgb(251, 108, 70);" href="__PLANER_EXCEL_LINK__">Fox Paradox Planer</a></strong> i zapisz go na swoim urządzeniu. To wszystko! Plik jest gotowy do edycji! 💻
                  </li>
                  <li style="position: relative; padding-left: 15px;">
                    <strong>Wersja Google Sheets:</strong> Kliknij tutaj: <strong><a style="color: rgb(251, 108, 70); text-decoration: none; border-bottom: 1px solid rgb(251, 108, 70);" href="__PLANER_GOOGLE_SHEETS_LINK__">Fox Paradox Planer</a></strong>, zaloguj się na konto Google, a następnie kliknij "Utwórz kopię", aby zapisać własny egzemplarz na swoim Dysku Google Drive. Od teraz możesz edytować arkusz i dostosować go do swoich potrzeb! 🚀
                  </li>
                </ul>
              </div>
            </div>
            
            <div style="display: flex; margin-bottom: 15px; align-items: flex-start;">
              <div style="min-width: 30px; color: rgb(251, 108, 70);"><strong>✅</strong></div>
              <div>
                <p style="margin: 0; line-height: 1.6;"><strong>Krok 4: Wskocz w środek przygody!</strong> Zacznij lekturę, podczas gdy ja będę przygotowywać Twój Spersonalizowany Plan Podróży. Otrzymasz go w ciągu 7 dni od dnia, w którym uzupełnisz ankietę. Zainspiruj się, poznaj sprawdzone atrakcje, ukryte perełki i konkretne wskazówki, które oszczędzą Ci stresu, czasu i przygotowań.</p>
              </div>
            </div>
            
            <div style="display: flex; align-items: flex-start;">
              <div style="min-width: 30px; color: rgb(251, 108, 70);"><strong>✅</strong></div>
              <div>
                <p style="margin: 0; line-height: 1.6;"><strong>Krok 5: Leć na Teneryfę, eksploruj i daj mi znać, jak było!</strong> Jeśli chcesz podzielić się swoimi wrażeniami, oznacz mnie na Instagramie <a style="color: rgb(251, 108, 70); text-decoration: none; font-weight: bold; border-bottom: 1px solid rgb(251, 108, 70);" href="https://www.instagram.com/foxparadox.insta/"><strong>@foxparadox.insta</strong></a> – z przyjemnością zobaczę Twoje podróżnicze chwile!</p>
              </div>
            </div>
          </div>
          
          <p style="line-height: 1.6;">A jeśli po przeczytaniu przewodnika będziesz mieć pytania lub zechcesz się ze mną podzielić opinią – śmiało pisz! Twoja feedbackowa supermoc pomoże mi tworzyć jeszcze lepsze materiały w przyszłości. 📙</p>
          
          <div style="margin-top: 30px; padding-top: 20px; border-top: 1px solid #ddd;">
            <p style="margin-bottom: 5px;">Miłego odkrywania,</p>
            <p style="font-weight: bold; margin-top: 0;">Magda Szabłowska</p>
          </div>
          
          <div style="text-align: center; margin-top: 20px; padding: 15px; background-color: #f9f9f9; border-radius: 8px;">
            <p style="margin: 0; font-size: 15px;">
              <strong>Instagram: <a style="color: rgb(251, 108, 70); text-decoration: none;" href="https://www.instagram.com/foxparadox.insta/">@foxparadox.insta</a></strong> | 
              <strong>Strona: <a style="color: rgb(240, 152, 25); text-decoration: none;" href="https://www.foxparadox.pl">www.foxparadox.pl</a></strong>
            </p>
          </div>
        </div>
      `;
    default:
      return '';
  }
};

export { getMessageContent };
